var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SACModal',{attrs:{"modalClass":"sh-action-modal","cardClass":`sh-${_vm.actionModalView}`,"show":_vm.showActionModal,"close":() => _vm.toggleActionModal(false)},scopedSlots:_vm._u([(_vm.actionModalView === 'csv-confirmation')?{key:"content",fn:function(){return [_c('ExportCSVConfirmation')]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }